import React, { FC } from 'react';
import { Flex, Text } from '@chakra-ui/react';

interface Props {
    fileName?: string;
    fileSize?: string;
}

const VideoInfo: FC<Props> = ({ fileName, fileSize }) => {
    if (!fileName && !fileSize) {
        return null;
    }

    return (
        <Flex direction="column" alignItems="center" gap="4px" pt="8px">
            {fileName && (
                <Text
                    color="white"
                    fontSize="16px"
                    lineHeight="1.4"
                    letterSpacing="0.25px"
                    fontWeight="normal"
                    textAlign="center"
                    noOfLines={1}
                >
                    {fileName}
                </Text>
            )}
            {fileSize && (
                <Text
                    color="#EDF1F3"
                    fontSize="12px"
                    lineHeight="1.3"
                    letterSpacing="0.75px"
                    fontWeight="normal"
                    textAlign="center"
                >
                    {fileSize}
                </Text>
            )}
        </Flex>
    );
};

export default VideoInfo;
